import { render } from "./PortfolioAnalytics.vue?vue&type=template&id=02a28448&scoped=true"
import script from "./PortfolioAnalytics.vue?vue&type=script&lang=js"
export * from "./PortfolioAnalytics.vue?vue&type=script&lang=js"

import "./PortfolioAnalytics.vue?vue&type=style&index=0&id=02a28448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a28448"]])

export default __exports__